import { render } from "./payment_settings.vue?vue&type=template&id=4282d66f"
import script from "./payment_settings.vue?vue&type=script&lang=js"
export * from "./payment_settings.vue?vue&type=script&lang=js"

import exportComponent from "/home/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"app/javascript/template_builder/payment_settings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4282d66f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4282d66f', __exports__)) {
    api.reload('4282d66f', __exports__)
  }
  
  module.hot.accept("./payment_settings.vue?vue&type=template&id=4282d66f", () => {
    api.rerender('4282d66f', render)
  })

}


export default __exports__